import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import classNames from 'classnames/bind';
import qs from 'qs';
import {createIntl, createIntlCache } from 'react-intl';
import { useHistory } from 'react-router-dom';
import OTPInput from 'components/OTPInput/OTPInput';
import { getTemplateString } from 'common/helpers/string';
import styles from './OTPVerification.module.scss';
import { fetcher } from 'app/http';
import TagManager from 'react-gtm-module';
import { getEncryptedValue } from 'common/helpers/Gtm';
import { formProgression } from 'common/helpers/Gtm';

type Props = {
  Model: any;
  PageData: any;
  onSubmit: (data: any) => void;
  onCancel: () => void;
  onBack: () => void;
  countrycode?: string;
  isOTPSubmitted ?: boolean;
};

export enum RESEND_CODE_STATUS {
  OK = 'ok',
  BLOCKED = 'blocked',
  REDIRECT = 'redirect',
  ERROR = 'error',
}

export const TIME_TO_CODE_RESEND = 60;
export const TIMEZONE_OFFSET = new Date().getTimezoneOffset() * -1;

// TODO: Check is it proper way
const cache = createIntlCache();

// TODO: Get current language
const intl = createIntl(
  {
    locale: 'fr',
  },
  cache,
);

const OTPVerification = ({
  Model,
  PageData,
  onSubmit,
  onCancel,
  onBack,
  countrycode,
  isOTPSubmitted
}: Props) => {
  const history = useHistory();
  const [disableResend, setDisableResend] = useState<boolean>(false);
  const [counter, setCounter] = useState<number>(TIME_TO_CODE_RESEND);
  const [statusMessage, setStatusMessage] = useState<string>('');
  const [showCounter, setShowCounter] = useState<boolean>(false);
  const [showResendSuccess, setShowResendSuccess] = useState<boolean>(false);
  const [verificationFailureCount, setVerificationFailureCount] = useState(Model?.FormModel?.VerificationFailureCount);
  const [eventTracked, setEventTracked] = useState<boolean>(false);

  const codeSentToMessage = Model?.IsLoginResetVerfication
    ? getTemplateString(PageData?.SentSecurityCodeToMobileModalText)
    : getTemplateString(PageData?.SentSecurityCodeToEmailModalText);
  const codeSendingBlockedError = getTemplateString(
    PageData?.CodeSendingBlockedError,
  );
  const {
    control,
    handleSubmit,
    register,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      FormModel: {
        ProfileId: Model?.FormModel?.ProfileId,
        DebtReference: Model?.FormModel?.DebtReference,
        MobileNumber: Model?.FormModel?.MobileNumber,
        VerificationFailureCount: Model?.FormModel?.VerificationFailureCount,
        key: Model?.FormModel?.key,
        EmailAddress: Model?.FormModel?.EmailAddress,
        AuthId: Model?.FormModel?.AuthId,
        Code1: undefined,
        Code2: undefined,
        Code3: undefined,
        Code4: undefined,
        Code5: undefined,
        Code6: undefined,
      },
    },
    mode: 'all',
  });

  const onFormSubmit = handleSubmit((data: any) => {
    data.FormModel.VerificationFailureCount = verificationFailureCount;
    onSubmit(data);
  });

  const handleOTPChange = (e: any, callback: Function) => {

    var maxlength = e.target.maxLength;
    var inputValue = e.target.value;
    var inputLength = inputValue.length;
    if(inputLength > (maxlength + 1))
    {
      return;
    }
    if(inputLength > maxlength)
    {
      var oldValue = getValues(e.target.name);      
      var reminder = inputValue % 10;
      var quotient = inputValue / 10;

      if(reminder == oldValue)
      {        
        e.target.value = Math.trunc(quotient);
      }
      else
      {
        e.target.value = reminder;
      }  
    }


    if (e.target.nextSibling && e.target.value) {
      e.target.nextSibling.focus();
    }
    callback(e.target.value);
  };

  const onResendCode = async (emailAddress?: string, mobileNumber?: string) => {
    try {
      setDisableResend(true);
      const data = qs.stringify({
        email: emailAddress,
        mobile: mobileNumber,
        key: Model?.FormModel?.key,
        debtReference: Model?.FormModel?.DebtReference,
        profileId: Model?.FormModel.ProfileId,
        timezoneOffsetInMinutes: TIMEZONE_OFFSET,
      });
      const response = await fetcher.post(Model?.ResendCodeLink, data);
      if (response.data) {
        const { data } = response;
        if (data.status === RESEND_CODE_STATUS.OK) {
          setShowResendSuccess(true);
        }
        if (data.status === RESEND_CODE_STATUS.BLOCKED) {
          setShowCounter(true);
          setStatusMessage(data?.message);
        }
        if (data.status === RESEND_CODE_STATUS.REDIRECT) {
          history.push(data.data);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const timer = setInterval(
      () => showCounter && counter > 0 && setCounter(counter - 1),
      1000,
    );
    return () => {
      clearInterval(timer);
    };
  }, [counter, showCounter]);

  useEffect(() => {
    if (counter === 0) {
      setShowCounter(false);
      setDisableResend(false);
      setCounter(TIME_TO_CODE_RESEND);
    }
  }, [counter]);

  useEffect(() => {
    setVerificationFailureCount(Model?.FormModel?.VerificationFailureCount);
  }, [Model]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowResendSuccess(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, [showResendSuccess]);


  useEffect(() => {
    var tagManagerArgs: any;
    if (eventTracked == false) {
      if (Model?.IsLoginResetVerfication) {
        if (Model?.FormModel?.DebtReference) {
          let encodedUserId = getEncryptedValue(Model?.FormModel?.DebtReference, countrycode)
          tagManagerArgs = {
            dataLayer: {
              event: 'forgot_password_init',
              reset_type: 'Email',
              user_id: encodedUserId
            },
          };
          TagManager.dataLayer(tagManagerArgs);
        }
        else {
          tagManagerArgs = {
            dataLayer: {
              event: 'forgot_password_init',
              reset_type: 'Email',
            },
          };
          TagManager.dataLayer(tagManagerArgs);
        }
      };
      if (Model?.IsResetPasswordVerification) {
        if (Model?.FormModel?.DebtReference) {
          let encodedUserId = getEncryptedValue(Model?.FormModel?.DebtReference, countrycode)
          tagManagerArgs = {
            dataLayer: {
              event: 'forgot_password_init',
              reset_type: 'Password',
              user_id: encodedUserId
            },
          };
          TagManager.dataLayer(tagManagerArgs);
        }
        else {
          tagManagerArgs = {
            dataLayer: {
              event: 'forgot_password_init',
              reset_type: 'Password',
            },
          };
          TagManager.dataLayer(tagManagerArgs);
        }
      };
      setEventTracked(true);
    }
  }, [eventTracked]);

  const onFocusOutOtpField = async (e:any,fieldName:any) => {
    formProgression(e,'Login/password reset otp Verification',fieldName)
  }
  return (
    <form
      onSubmit={onFormSubmit}
      // action="@Model.PostCodeLink"
      // method="post"
      className={styles.form}
    >
      <div className={styles.heading}>
        {PageData?.SentSecurityCodeModalHeader}
      </div>
      <p className={styles.text}>
        {codeSentToMessage &&
          Model.IsLoginResetVerfication &&
          codeSentToMessage({ MobileNumber: Model?.FormModel?.MobileNumber })}
        {codeSentToMessage &&
          !Model.IsLoginResetVerfication &&
          codeSentToMessage({ EmailAddress: Model?.FormModel?.EmailAddress })}
      </p>
      <div
        className={classNames(
          'form-group',
          Model.VerificationFailure && 'error-message',
        )}
      >

        <label className={styles.label}>{PageData?.VerifyCodeModalLabel}</label>
        <div className={styles.inputsWrapper}>

          <Controller
            control={control}
            name={'FormModel.Code1'}
            render={({ field: { onChange, name, value } }) => (
              <OTPInput
                name={name}
                value={value}
                onChange={(e) => handleOTPChange(e, onChange)}
                onBlur = {(e)=> onFocusOutOtpField(e,'code1')}
              />
            )}
            rules={{
              required: true,
            }}
          />
          <Controller
            control={control}
            name={'FormModel.Code2'}
            render={({ field: { onChange, name, value } }) => (
              <OTPInput
                name={name}
                value={value}
                onChange={(e) => handleOTPChange(e, onChange)}
                onBlur = {(e)=> onFocusOutOtpField(e,'code2')}
              />
            )}
            rules={{
              required: true,
            }}
          />
          <Controller
            control={control}
            name={'FormModel.Code3'}
            render={({ field: { onChange, name, value } }) => (
              <OTPInput
                name={name}
                value={value}
                onChange={(e) => handleOTPChange(e, onChange)}
                onBlur = {(e)=> onFocusOutOtpField(e,'code3')}
              />
            )}
            rules={{
              required: true,
            }}
          />
          <Controller
            control={control}
            name={'FormModel.Code4'}
            render={({ field: { onChange, name, value } }) => (
              <OTPInput
                name={name}
                value={value}
                onChange={(e) => handleOTPChange(e, onChange)}
                onBlur = {(e)=> onFocusOutOtpField(e,'code4')}
              />
            )}
            rules={{
              required: true,
            }}
          />
          <Controller
            control={control}
            name={'FormModel.Code5'}
            render={({ field: { onChange, name, value } }) => (
              <OTPInput
                name={name}
                value={value}
                onChange={(e) => handleOTPChange(e, onChange)}
                onBlur = {(e)=> onFocusOutOtpField(e,'code5')}
              />
            )}
            rules={{
              required: true,
            }}
          />
          <Controller
            control={control}
            name={'FormModel.Code6'}
            render={({ field: { onChange, name, value } }) => (
              <OTPInput
                name={name}
                value={value}
                onChange={(e) => handleOTPChange(e, onChange)}
                onBlur = {(e)=> onFocusOutOtpField(e,'code6')}
              />
            )}
            rules={{
              required: true,
            }}
          />
        </div>
        {Model?.VerificationFailure && (
          <span className={styles.error}>
            {PageData?.IncorrectCodeErrorMessage}
          </span>
        )}
        {Model?.VerificationLimitExcceded && (
          <span className={styles.error}>
            {PageData?.ExceededVerificationLimitLabelLabel}
          </span>
        )}
        {Model?.ShowSendingBlockedError && (
          <span className={styles.error}>
            {codeSendingBlockedError &&
              Model?.BlockedUntil &&
              codeSendingBlockedError({
                BlockedUntil: intl.formatDate(new Date(Model?.BlockedUntil), {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                })
              })}
          </span>
        )}
      </div>

      <div className="u-marginBxmd u-textCenter form-text">
        {Model?.IsLoginResetVerfication && (
          <button
            type="button"
            onClick={() =>
              onResendCode(undefined, Model.FormModel.MobileNumber)
            }
            disabled={disableResend || Model?.ShowSendingBlockedError}
            className={classNames(
              'form-text-bold u-textdecoration',
              (disableResend || Model?.ShowSendingBlockedError) &&
              styles.disabled,
            )}
          >
            {PageData?.SendCodeAgainModalLabel}
          </button>
        )}
        {Model?.IsResetPasswordVerification && (
          <button
            type="button"
            onClick={() => onResendCode(Model?.FormModel?.EmailAddress)}
            disabled={disableResend}
            className={classNames(
              'form-text-bold u-textdecoration',
              disableResend && styles.disabled,
            )}
          >
            {PageData?.SendCodeAgainModalLabel}
          </button>
        )}
      </div>

      <div className="u-marginBxmd u-textCenter">
        <button
          type="submit"
          className={classNames(
            isValid ? 'Button w-100 verifycode' : isOTPSubmitted == true ? 'Button Button--gray w-100' : 'Button Button--gray w-100',
          )}
          disabled={!isValid || isOTPSubmitted == true }
        >
          <span>{PageData?.VerifyCodeModalButtonLabel}</span>
        </button>
      </div>
      <div className="u-textCenter">
        <p className="form-text">
          <button onClick={onBack} className="u-textWeightBold">
            {PageData?.GoBackModalLinkLabel}
          </button>
        </p>
      </div>
      <div className={styles.sendCodeStatus}>
        {showResendSuccess && (
          <div className={classNames(styles.statusBadge, styles.ok)}>
            {PageData?.NewCodeSentButtonLabel}
          </div>
        )}
        {showCounter && (
          <div className={classNames(styles.statusBadge, styles.blocked)}>
            <span>
              {PageData?.RequestANewCodeButtonLabel}
              <strong className={styles.timer}>
                {` `}
                {counter}
                {` `}
              </strong>
              {PageData?.SecondsLabel}
            </span>
          </div>
        )}
      </div>
    </form>
  );
};

export default OTPVerification;
